import { Box, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
// import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';
import { editBgColor } from 'src/store/modules/imageUpload';
// import ChevronUp from 'src/components/Icon/ChevronUp';
// import ChevronDown from 'src/components/Icon/ChevronDown';
import BgPicker from '../BgPicker';
import { BgColor } from '../EditBgColorRegurcy/EditBgColor';
import { BgImage } from '../EditBgImageRegurcy/EditBgImage';

interface editTextProps {
  menuTitle?: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '20px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #E5E8EB',
    borderRadius: '8px'
  },
  fontBox: {
    width: '100%',
    height: '44px',
    padding: '0 12px',
    cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    color: '#191F28',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  },
  input: {
    height: '80px',
    padding: '12px',
    outline: 'none',
    overflow: 'hidden',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA',
    color: '#191F28',
    '&:focus': {
      borderColor: '#191F28',
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#191F28'
  },

  bottomBtn: {
    padding: '8px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA'
  },
  btnMinusPlus: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E8EB',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  },

  fontNumber: {
    width: '48px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#191F28',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E8EB'
  },

  buttonWrapper: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    borderRadius: '6px'
  },
  buttonImage: {
    maxWidth: '24px',
    minWidth: '24px',
    maxHeight: '24px',
    minHeight: '24px'
  },

  boxWrapper: {
    padding: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA'
  },
  colorBox: {
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: '#F2F3F5',
    textAlign: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '6px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  }
}));

const EditBg: FC<editTextProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const {
    refPicker,
    refButton1,
    refButton2,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);
  const [isCheck, setIsCheck] = useState(false);

  const handleColor = c => {
    const newBgColor = JSON.parse(`{"${type}": "${c.hex}"}`);
    dispatch(editBgColor({ ...bgColor, ...newBgColor }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '13px',
          fontWeight: 600,
          fontFamily: "'Poppins', sans-serif",
          color: '#191F28',
          letterSpacing: '0.02em'
        }}
      >
        {menuTitle || 'BACKGROUND'}
      </div>
      <div>
        <Box className={classes.boxWrapper}>
          {bg === 'image' ? (
            <BgImage type={type} />
          ) : (
            <>
              <BgColor
                type={type}
                picker={{
                  refPicker,
                  refButton1,
                  refButton2,
                  isComponentVisible,
                  setIsComponentVisible
                }}
              />
              <Box
                style={{ cursor: 'pointer' }}
                onClick={() => setIsCheck(!isCheck)}
              >
                {/* {isCheck ? (
                  <ChevronUp
                    style={{
                      width: '1.5rem',
                      height: '1.5rem'
                    }}
                  />
                ) : (
                  <ChevronDown
                    style={{
                      width: '1.5rem',
                      height: '1.5rem'
                    }}
                  />
                )} */}
              </Box>
            </>
          )}
        </Box>
        {isCheck && <BgPicker onClose={() => setIsCheck(!isCheck)} />}
        {isComponentVisible && (
          <div ref={refPicker} style={{ width: '100%', marginTop: '1rem' }}>
            <ChromePicker
              color={bgColor[type]}
              onChange={handleColor}
              disableAlpha
              width="100%"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditBg;
